import Vue from 'vue'
import Vuelidate from 'vuelidate'
import vueMask from 'vue-jquery-mask';

Vue.use(Vuelidate)
Vue.use(vueMask);
// import VueMoment from 'vue-moment'
// const moment = require('moment');

import moment from 'moment'

import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// const localeRu = require('moment/locale/ru');

moment.locale('ru', {
    months : ['Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня', 'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря'],
});

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY');
  }
});

Vue.filter('splitNumber', function (value) {
   return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
